[
  {
    "id": "mostUsed",
    "icons": [
      { "id": "cross_black_thick_v1" },
      { "id": "cross_thick_v1" },
      {
        "id": "01_Gleise_db_gleis_01_v1"
      },
      {
        "id": "01_Gleise_db_gleis_02_v1"
      },
      {
        "id": "01_Gleise_db_gleis_03_v1"
      },
      {
        "id": "01_Gleise_db_gleis_04_v1"
      },
      {
        "id": "01_Gleise_db_gleis_05_v1"
      },
      {
        "id": "01_Gleise_db_gleis_06_v1"
      },
      {
        "id": "01_Gleise_db_gleis_07_v1"
      },
      {
        "id": "01_Gleise_db_gleis_08_v1"
      },
      {
        "id": "01_Gleise_db_gleis_09_v1"
      }
    ]
  },
  {
    "id": "01_Gleise",
    "icons": [
      {
        "id": "01_Gleise_db_gleis_01_v1"
      },
      {
        "id": "01_Gleise_db_gleis_02_v1"
      },
      {
        "id": "01_Gleise_db_gleis_03_v1"
      },
      {
        "id": "01_Gleise_db_gleis_04_v1"
      },
      {
        "id": "01_Gleise_db_gleis_05_v1"
      },
      {
        "id": "01_Gleise_db_gleis_06_v1"
      },
      {
        "id": "01_Gleise_db_gleis_07_v1"
      },
      {
        "id": "01_Gleise_db_gleis_08_v1"
      },
      {
        "id": "01_Gleise_db_gleis_09_v1"
      },
      {
        "id": "01_Gleise_db_gleis_10_v1"
      },
      {
        "id": "01_Gleise_db_gleis_11_v1"
      },
      {
        "id": "01_Gleise_db_gleis_12_v1"
      },
      {
        "id": "01_Gleise_db_gleis_13_v1"
      },
      {
        "id": "01_Gleise_db_gleis_14_v1"
      },
      {
        "id": "01_Gleise_db_gleis_15_v1"
      },
      {
        "id": "01_Gleise_db_gleis_16_v1"
      },
      {
        "id": "01_Gleise_db_gleis_17_v1"
      },
      {
        "id": "01_Gleise_db_gleis_18_v1"
      },
      {
        "id": "01_Gleise_db_gleis_19_v1"
      },
      {
        "id": "01_Gleise_db_gleis_20_v1"
      },
      {
        "id": "01_Gleise_db_gleis_21_v1"
      },
      {
        "id": "01_Gleise_db_gleis_22_v1"
      },
      {
        "id": "01_Gleise_db_gleis_23_v1"
      },
      {
        "id": "01_Gleise_db_gleis_24_v1"
      },
      {
        "id": "01_Gleise_db_gleis_25_v1"
      },
      {
        "id": "01_Gleise_db_gleis_26_v1"
      },
      {
        "id": "01_Gleise_db_gleis_27_v1"
      },
      {
        "id": "01_Gleise_db_gleis_28_v1"
      },
      {
        "id": "01_Gleise_db_gleis_29_v1"
      },
      {
        "id": "01_Gleise_db_gleis_30_v1"
      }
    ]
  },
  {
    "id": "01_Verkehrsmittel",
    "icons": [
      {
        "id": "01_Verkehrsmittel_05_080_Fahrradabstellplatz-1_v1"
      },
      {
        "id": "01_Verkehrsmittel_05_082_Fahrradbox-1_v1"
      },
      {
        "id": "01_Verkehrsmittel_06_002_Carsharing-1_v1"
      },
      {
        "id": "01_Verkehrsmittel_06_003_MietwagenService-1_v1"
      },
      {
        "id": "01_Verkehrsmittel_06_020_Call_a_Bike-1_v1"
      },
      {
        "id": "01_Verkehrsmittel_06_021_RadStation-1_v1"
      },
      {
        "id": "03_vorschriftszeichen_224_v1"
      }
    ]
  },
  {
    "id": "01_gefahren",
    "icons": [
      {
        "id": "01_gefahren_101_v1"
      },
      {
        "id": "01_gefahren_102_v1"
      },
      {
        "id": "01_gefahren_103-10_v1"
      },
      {
        "id": "01_gefahren_105-10_v1"
      },
      {
        "id": "01_gefahren_108-10_v1"
      },
      {
        "id": "01_gefahren_110-12_v1"
      },
      {
        "id": "01_gefahren_112_v1"
      },
      {
        "id": "01_gefahren_114_v1"
      },
      {
        "id": "01_gefahren_117-10_v1"
      },
      {
        "id": "01_gefahren_120_v1"
      },
      {
        "id": "01_gefahren_121-10_v1"
      },
      {
        "id": "01_gefahren_123_v1"
      },
      {
        "id": "01_gefahren_124_v1"
      },
      {
        "id": "01_gefahren_125_v1"
      },
      {
        "id": "01_gefahren_131_v1"
      },
      {
        "id": "01_gefahren_133-10_v1"
      },
      {
        "id": "01_gefahren_136-10_v1"
      },
      {
        "id": "01_gefahren_138-10_v1"
      },
      {
        "id": "01_gefahren_142-10_v1"
      },
      {
        "id": "01_gefahren_151_v1"
      },
      {
        "id": "01_gefahren_205_v1"
      }
    ]
  },
  {
    "id": "03_vorschriftszeichen",
    "icons": [
      {
        "id": "03_vorschriftszeichen_201-50_v1"
      },
      {
        "id": "03_vorschriftszeichen_206_v1"
      },
      {
        "id": "03_vorschriftszeichen_208_v1"
      },
      {
        "id": "03_vorschriftszeichen_209_v1"
      },
      {
        "id": "03_vorschriftszeichen_211_v1"
      },
      {
        "id": "03_vorschriftszeichen_214_v1"
      },
      {
        "id": "03_vorschriftszeichen_215_v1"
      },
      {
        "id": "03_vorschriftszeichen_220-20_v1"
      },
      {
        "id": "03_vorschriftszeichen_222_v1"
      },
      {
        "id": "03_vorschriftszeichen_223.1-50_v1"
      },
      {
        "id": "03_vorschriftszeichen_223.2-50_v1"
      },
      {
        "id": "03_vorschriftszeichen_223.3-50_v1"
      },
      {
        "id": "03_vorschriftszeichen_229_v1"
      },
      {
        "id": "03_vorschriftszeichen_237_v1"
      },
      {
        "id": "03_vorschriftszeichen_238_v1"
      },
      {
        "id": "03_vorschriftszeichen_239_v1"
      },
      {
        "id": "03_vorschriftszeichen_240_v1"
      },
      {
        "id": "03_vorschriftszeichen_241-30_v1"
      },
      {
        "id": "03_vorschriftszeichen_242.1_v1"
      },
      {
        "id": "03_vorschriftszeichen_242.2_v1"
      },
      {
        "id": "03_vorschriftszeichen_244.1_v1"
      },
      {
        "id": "03_vorschriftszeichen_244.2_v1"
      },
      {
        "id": "03_vorschriftszeichen_244.3_v1"
      },
      {
        "id": "03_vorschriftszeichen_244.4_v1"
      },
      {
        "id": "03_vorschriftszeichen_245_v1"
      },
      {
        "id": "03_vorschriftszeichen_250_v1"
      },
      {
        "id": "03_vorschriftszeichen_251_v1"
      },
      {
        "id": "03_vorschriftszeichen_253_v1"
      },
      {
        "id": "03_vorschriftszeichen_254_v1"
      },
      {
        "id": "03_vorschriftszeichen_255_v1"
      },
      {
        "id": "03_vorschriftszeichen_259_v1"
      },
      {
        "id": "03_vorschriftszeichen_260_v1"
      },
      {
        "id": "03_vorschriftszeichen_261_v1"
      },
      {
        "id": "03_vorschriftszeichen_262_v1"
      },
      {
        "id": "03_vorschriftszeichen_263_v1"
      },
      {
        "id": "03_vorschriftszeichen_264_v1"
      },
      {
        "id": "03_vorschriftszeichen_265_v1"
      },
      {
        "id": "03_vorschriftszeichen_266_v1"
      },
      {
        "id": "03_vorschriftszeichen_267_v1"
      },
      {
        "id": "03_vorschriftszeichen_268_v1"
      },
      {
        "id": "03_vorschriftszeichen_269_v1"
      },
      {
        "id": "03_vorschriftszeichen_270.1_v1"
      },
      {
        "id": "03_vorschriftszeichen_270.2_v1"
      },
      {
        "id": "03_vorschriftszeichen_272_v1"
      },
      {
        "id": "03_vorschriftszeichen_273_v1"
      },
      {
        "id": "03_vorschriftszeichen_274-60_v1"
      },
      {
        "id": "03_vorschriftszeichen_274.1_v1"
      },
      {
        "id": "03_vorschriftszeichen_274.2_v1"
      },
      {
        "id": "03_vorschriftszeichen_275_v1"
      },
      {
        "id": "03_vorschriftszeichen_276_v1"
      },
      {
        "id": "03_vorschriftszeichen_277.1_v1"
      },
      {
        "id": "03_vorschriftszeichen_277_v1"
      },
      {
        "id": "03_vorschriftszeichen_278-60_v1"
      },
      {
        "id": "03_vorschriftszeichen_279_v1"
      },
      {
        "id": "03_vorschriftszeichen_280_v1"
      },
      {
        "id": "03_vorschriftszeichen_281.1_v1"
      },
      {
        "id": "03_vorschriftszeichen_281_v1"
      },
      {
        "id": "03_vorschriftszeichen_282_v1"
      },
      {
        "id": "03_vorschriftszeichen_283_v1"
      },
      {
        "id": "03_vorschriftszeichen_286_v1"
      },
      {
        "id": "03_vorschriftszeichen_290.1_v1"
      },
      {
        "id": "03_vorschriftszeichen_290.2_v1"
      },
      {
        "id": "03_vorschriftszeichen_301_v1"
      },
      {
        "id": "03_vorschriftszeichen_306_v1"
      },
      {
        "id": "03_vorschriftszeichen_307_v1"
      },
      {
        "id": "03_vorschriftszeichen_308_v1"
      }
    ]
  },
  {
    "id": "06_richtzeichen",
    "icons": [
      {
        "id": "06_richtzeichen_314.1_v1"
      },
      {
        "id": "06_richtzeichen_314.2_v1"
      },
      {
        "id": "06_richtzeichen_314_v1"
      },
      {
        "id": "06_richtzeichen_315-55_v1"
      },
      {
        "id": "06_richtzeichen_318_v1"
      },
      {
        "id": "06_richtzeichen_325.1_v1"
      },
      {
        "id": "06_richtzeichen_325.2_v1"
      },
      {
        "id": "06_richtzeichen_327_v1"
      },
      {
        "id": "06_richtzeichen_328_v1"
      },
      {
        "id": "06_richtzeichen_330.1_v1"
      },
      {
        "id": "06_richtzeichen_330.2_v1"
      },
      {
        "id": "06_richtzeichen_331.1_v1"
      },
      {
        "id": "06_richtzeichen_331.2_v1"
      },
      {
        "id": "06_richtzeichen_333_v1"
      },
      {
        "id": "06_richtzeichen_350-10_v1"
      },
      {
        "id": "06_richtzeichen_350.1_v1"
      },
      {
        "id": "06_richtzeichen_350.2_v1"
      },
      {
        "id": "06_richtzeichen_354_v1"
      },
      {
        "id": "06_richtzeichen_356_v1"
      },
      {
        "id": "06_richtzeichen_357_v1"
      },
      {
        "id": "06_richtzeichen_358_v1"
      },
      {
        "id": "06_richtzeichen_363_v1"
      },
      {
        "id": "06_richtzeichen_390_v1"
      },
      {
        "id": "06_richtzeichen_391_v1"
      },
      {
        "id": "06_richtzeichen_392_v1"
      },
      {
        "id": "06_richtzeichen_393_v1"
      },
      {
        "id": "06_richtzeichen_401_v1"
      },
      {
        "id": "06_richtzeichen_405_v1"
      },
      {
        "id": "06_richtzeichen_406_v1"
      },
      {
        "id": "06_richtzeichen_410_v1"
      },
      {
        "id": "06_richtzeichen_421-20_v1"
      },
      {
        "id": "06_richtzeichen_422-20_v1"
      },
      {
        "id": "06_richtzeichen_432-20_v1"
      },
      {
        "id": "06_richtzeichen_442-20_v1"
      },
      {
        "id": "06_richtzeichen_448.1_v1"
      },
      {
        "id": "06_richtzeichen_450-51_v1"
      },
      {
        "id": "06_richtzeichen_454-20_v1"
      },
      {
        "id": "06_richtzeichen_455.1-30_v1"
      },
      {
        "id": "06_richtzeichen_455.2_v1"
      },
      {
        "id": "06_richtzeichen_457.1_v1"
      },
      {
        "id": "06_richtzeichen_457.2_v1"
      },
      {
        "id": "06_richtzeichen_460-30_v1"
      },
      {
        "id": "06_richtzeichen_467.1-20_v1"
      },
      {
        "id": "06_richtzeichen_467.2_v1"
      },
      {
        "id": "06_richtzeichen_501-11_v1"
      },
      {
        "id": "06_richtzeichen_531-10_v1"
      },
      {
        "id": "06_richtzeichen_590-10_v1"
      }
    ]
  },
  {
    "id": "10_zusatzzeichen",
    "icons": [
      {
        "id": "10_zusatzzeichen_1031-50_v1"
      },
      {
        "id": "10_zusatzzeichen_615_v1"
      },
      {
        "id": "10_zusatzzeichen_616_v1"
      },
      {
        "id": "10_zusatzzeichen_630_v1"
      },
      {
        "id": "10_zusatzzeichen_720_v1"
      },
      {
        "id": "10_zusatzzeichen_721_v1"
      },
      {
        "id": "10_zusatzzeichen_Carsharing-Plakette_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_1000-32_72c7489aca_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_1001-31.2_bd2792051d_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_1001-31_ccd45c96dd_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_1002-10_eb632bc0c5_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_1002-21_5e61177cf7_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_1004-30_a721f1a690_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_1004-32_46b7a0557a_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_1005-30_b815319a6f_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_1010-56_8370974738_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_1020-11_0fcf5ac24e_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_1020-13_298145b3b5_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_1020-32_eb03c878d7_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_1022-10_4a33da4553_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_1022-16_1cc8596121_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_1024-20_7e3ecfbb2f_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_1024-21_868ff83700_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_1024-22_6765958919_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_1053-33.2_4265e359e6_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_1053-33_9b656baffb_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_1053-34_a3a5ec8cca_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_1053-35_e19df6911e_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_1053-36_4f0a51333d_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_1053-37_cbd49b4e1c_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_1060-31_638712cbd1_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_1060-32_57bd82b452_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_Kfz_frei_9fa42ebae3_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_Amphibienwanderung_cff176d3ef_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_Autobahnausfahrt_940eab6ce0_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_Autobahnkreuz_8607bca3ad_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_Bewegliche_Bruecke_85df0a040b_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_Carsharing_624947e7a9_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_E-Bikes_152c97881a_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_E-Fahrzeug_f6fd2d0f68_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_Elektrokleinstfahrzeug_fb6707a410_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_Flugbetrieb_4be6f7a369_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_Fussgaenger_67d5382bf1_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_Fussgaengerueberweg_de013479b7_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_Gespannfuhrwerke_56694006f4_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_Kfz_17b8df1569_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_Kraftomnibus_1dff01a936_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_Kraftrad_8548268e4b_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_Lastenfahrrad_70fd85da1d_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_Lkw_551d129426_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_Lkw_mit_Anhaenger_84c832c328_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_Mofa_3caa91f170_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_Pkw_ebf207022d_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_Pkw_mit_Anhaenger_254214e81c_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_Radfahrer_d16d08474d_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_Reiter_b506cdf782_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_Schnee-_oder_Eisglaette_0374a20d40_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_Splitt_Schotter_448144229e_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_Steinschlag_ebfcde1238_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_Strassenbahn_7fa0c9a311_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_Traktor_7ca44142f8_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_Ufer_3ddbbc497f_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_Unzureichendes_Lichtraumprofil_bac305abc9_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_Viehtrieb_b619791f05_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_Wohnmobil_b9a472c9fa_v1"
      },
      {
        "id": "10_zusatzzeichen_csm_mehrfachbesetzte_Pkw_ed8551e1c4_v1"
      }
    ]
  },
  {
    "id": "Lageplan",
    "icons": [
      {
        "id": "Lageplan_09_001_Rauchen_nicht_gestattet_-1_v1"
      }
    ]
  },
  {
    "id": "04_rest",
    "icons": [
      {
        "id": "street_049_v1"
      },
      {
        "id": "street_050_v1"
      },
      {
        "id": "street_051_v1"
      },
      {
        "id": "street_052_v1"
      },
      {
        "id": "street_053_v1"
      },
      {
        "id": "street_054_v1"
      },
      {
        "id": "street_055_v1"
      },
      {
        "id": "street_056_v1"
      },
      {
        "id": "street_057_v1"
      },
      {
        "id": "street_058_v1"
      },
      {
        "id": "street_059_v1"
      },
      {
        "id": "street_060_v1"
      },
      {
        "id": "street_061_v1"
      },
      {
        "id": "street_061_alt_v1"
      },
      {
        "id": "street_062_v1"
      },
      {
        "id": "street_063_v1"
      },
      {
        "id": "street_064_v1"
      },
      {
        "id": "street_065_v1"
      },
      {
        "id": "street_066_v1"
      },
      {
        "id": "street_067_v1"
      },
      {
        "id": "street_068_v1"
      },
      {
        "id": "street_069_v1"
      },
      {
        "id": "street_070_v1"
      },
      {
        "id": "street_071_v1"
      },
      {
        "id": "street_072_v1"
      },
      {
        "id": "street_073_v1"
      },
      {
        "id": "street_074_v1"
      },
      {
        "id": "street_075_v1"
      }
    ]
  }
]
